import { render, staticRenderFns } from "./MoleculeEditionAcademyUsersProfileSalesRecord.vue?vue&type=template&id=1fd296de&"
import script from "./MoleculeEditionAcademyUsersProfileSalesRecord.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyUsersProfileSalesRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports